import 'react-app-polyfill/stable';
import "public/css/core.scss";

import ReactDOM from "react-dom";
import Application from "pages/app";
import React from "react";

//inject <link>
const link = document.createElement('link');
link.href = `${window.weezConfig.weezStatic}/icons/WeezFont.css`;
link.rel='stylesheet';
link.type='text/css';
document.getElementsByTagName('head')[0].appendChild(link);

const node = document.getElementById("root");

ReactDOM.render(<Application />, node);
